export default {
  d: {
    default: '1.5em',
    type: [String, Number]
  },

  color: {
    default: '#eee'
  },

  rainbow: Boolean,

  strokeWidth: {
    default: 2,
    type: Number
  },

  duration: {
    default: 2,
    type: Number
  }
}



// WEBPACK FOOTER //
// ./src/components/Spinner/_props.js